import React from 'react'
import { Link } from 'react-router-dom'
import Tippy from '@tippy.js/react'
import { Row, Cover, Poster } from '../components'
import data from '../assets/data/services.js'
import '../assets/css/tippy.css'
import '../assets/css/fa.css'

const anotherRow = data.splice(3)

export default (props) => {
	const { services, index } = props
	return(<>
			<Cover clsName='servicesCover'>
				<Poster title='Our Services' subtitle='The thing we do with love.'>
					<Tippy content='Come home'>
						<Link to='/' className='btn-primary'>Back home</Link>
					</Tippy>
				</Poster>
			</Cover>

		<div className="container mb5" id="container" key='0'>
 			{
 					<Row services={data} index='1' key='5000' />
 			}
 			{
 					<Row services={anotherRow} index='100' key='6000' />
 			}
		</div>
	</>)
}